import apiRequest from "../../helpers/apiRequest";

export default async (user, tutor, title, availability, packages, package_price, timeZone) => {
    return await apiRequest({
        method: "post",
        url: `content/individual/appointment/`,
        data: {user, tutor, title, availability, packages, package_price, timeZone},
    });
};
